module.exports = __webpack_public_path__ + "img/projectscore.642a85e7.png";